module.exports = __webpack_public_path__ + "static/media/landingpage.14e2befa.png";